"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var PageMessage = /** @class */ (function (_super) {
    tslib_1.__extends(PageMessage, _super);
    function PageMessage(props, context) {
        return _super.call(this, props, context) || this;
    }
    PageMessage.prototype.render = function () {
        var _a;
        var _b = this.props, theme = _b.theme, className = _b.className, iconName = _b.iconName, iconSize = _b.iconSize, iconClass = _b.iconClass, title = _b.title, titleClass = _b.titleClass, description = _b.description, descriptionClass = _b.descriptionClass, small = _b.small, others = tslib_1.__rest(_b, ["theme", "className", "iconName", "iconSize", "iconClass", "title", "titleClass", "description", "descriptionClass", "small"]);
        var classes = classnames_1.default(theme.message, className, (_a = {},
            _a[theme.small] = small,
            _a));
        var iconClasses = classnames_1.default(theme.icon, iconClass);
        var titleClasses = classnames_1.default(theme.title, titleClass);
        var descriptionClasses = classnames_1.default(theme.description, descriptionClass);
        return (React.createElement("div", { className: classes },
            iconName
                ? React.createElement(icon_1.Icon, { className: iconClasses, iconName: iconName, size: iconSize })
                : null,
            title
                ? React.createElement("div", { className: titleClasses }, title)
                : null,
            description
                ? React.createElement("div", { className: descriptionClasses, dangerouslySetInnerHTML: { __html: description } })
                : null));
    };
    PageMessage.defaultProps = {
        iconSize: 6
    };
    return PageMessage;
}(React.Component));
exports.default = PageMessage;
